export const reverseDcTableKeys = [
  { name: "DC Number", key: "dcNo" },
  {
    name: "Created At",
    key: "createdAt",
    isDate: true,
  },
];
